<script>
  import AdGroupForm from './AdGroupForm.vue'
  import BannerPosition from './BannerPosition.vue'
  import OperationButtons from './OperationButtons.vue'
  import BannerPreview from '../BannerPreview.vue'
  import { addOrUpdateAdGroup } from '@/api/marketing/adGroup'
  import { getBannerTemList } from '@/api/bottomBannerDefault/index'
  import { advertisingLocation } from '@/api/marketing/advertising'

  export default {
    name: 'AdGroupEditor',
    components: {
      AdGroupForm,
      BannerPosition,
      OperationButtons,
      BannerPreview
    },
    props: {
      // 编辑数据
      editData: {
        type: Object,
        default: () => null
      },
      // 是否编辑模式
      isEdit: {
        type: Boolean,
        default: false
      },
      // 是否简化模式（用于图5的场景）
      isSimpleMode: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        form: {
          name: '',
          templateId: '',
          weights: 1,
          adTemplateName: '',
          slotKeys: [],
          startTime: '',
          endTime: '',
          allArea: 1,
          areaIdList: [],
          displayChannelList: []
        },
        slotKeys: [],
        defaultBanners: [],
        previewImage: '',
        isLoading: false,
        bannerTemplates: [],
        locationKeyList: [],
        cacheEnabled: false // 默认禁用缓存
      }
    },
    computed: {
      // 预览图片
      previewImg() {
        const map = new Map([
          [1, require('@/assets/images/banner/banner1View.jpg')],
          [2, require('@/assets/images/banner/banner2View.jpg')],
          [3, require('@/assets/images/banner/banner3View.jpg')],
          [4, require('@/assets/images/banner/banner4View.jpg')]
        ])
        return map.get(this.form.templateId) || ''
      }
    },
    created() {
      this.fetchBannerTemplates()
      advertisingLocation().then((res) => {
        const { data, code } = res
        if (code === 0) {
          this.locationKeyList = data
        }
      })
    },
    methods: {
      // 获取banner模板列表
      fetchBannerTemplates() {
        getBannerTemList({ templateHaveDefaultBanner: true }).then((res) => {
          const { code, data } = res
          if (code === 0) {
            this.bannerTemplates = data || []
            this.initData()
          }
        })
      },
      // 初始化数据
      async initData() {
        // 检查是否有缓存数据
        const adGroupCache = localStorage.getItem('adGroupCache')

        console.log('adGroupCache', adGroupCache)

        if (adGroupCache) {
          try {
            // 解析缓存数据但先不应用
            const cachedData = JSON.parse(adGroupCache)

            // 询问用户是否使用缓存
            this.$confirm('检测到上次未完成的编辑数据，是否继续编辑?', '提示', {
              confirmButtonText: '继续编辑',
              cancelButtonText: '重新开始',
              type: 'info'
            })
              .then(() => {
                // 用户选择继续编辑，应用缓存数据
                if (cachedData.baseForm) {
                  this.form = { ...cachedData.baseForm }
                  // 如果有模板ID，设置slotKeys
                  const { templateId } = this.form
                  if (templateId) {
                    const temItem = this.bannerTemplates.find((item) => item.id === templateId)
                    if (temItem) {
                      this.slotKeys = temItem.slotKeys || []
                      this.$set(this.form, 'slotKey', this.slotKeys[0])
                    }
                  }
                }

                // 启用缓存功能
                this.cacheEnabled = true

                // 通知子组件加载缓存数据
                this.$nextTick(() => {
                  if (this.$refs.bannerPosition) {
                    this.$refs.bannerPosition.loadCachedData(cachedData.dataMap || {})
                  }
                })
              })
              .catch(() => {
                // 用户选择不使用缓存，清除缓存并重新初始化
                this.clearCache()
                this.initFromEditData()
              })
          } catch (error) {
            console.error('恢复缓存数据失败:', error)
            this.clearCache()
            this.initFromEditData()
          }
        } else {
          // 编辑模式或没有缓存
          this.initFromEditData()
        }
      },

      // 从编辑数据初始化
      initFromEditData() {
        if (this.isEdit && this.editData) {
          // bannerList
          const { adGroup, bannerList } = this.editData
          this.form = { ...adGroup }
          const { templateId } = adGroup
          const temItem = this.bannerTemplates.find((item) => item.id === templateId)
          if (temItem) {
            this.slotKeys = temItem.slotKeys || []
            this.defaultBanners = bannerList
            this.$set(this.form, 'slotKey', this.slotKeys[0])
          }

          // 编辑模式下也启用缓存，以便保存用户的修改
          this.cacheEnabled = true
        } else {
          // 新增模式也启用缓存
          this.cacheEnabled = true
        }
      },

      // 处理模板变更
      handleTemplateChange({ slotKeys }) {
        this.slotKeys = slotKeys || []

        // 设置第一个位置为激活状态
        if (this.slotKeys && this.slotKeys.length > 0) {
          this.form.slotKey = this.slotKeys[0]

          // 通知BannerPosition组件更新当前位置
          this.$nextTick(() => {
            if (this.$refs.bannerPosition) {
              this.$refs.bannerPosition.updateCurrentPosition(this.slotKeys[0])
            }
          })
        }
      },

      // 处理表单变更
      handleFormChange(formData) {
        this.form = { ...this.form, ...formData }
      },

      // 处理banner位置变更
      handleBannerPositionChange(data) {
        if (data && data.slotKey) {
          this.form.slotKey = data.slotKey
        }
      },

      // 清除缓存
      clearCache() {
        localStorage.removeItem('adGroupCache')
        this.cacheEnabled = false
      },

      // 校验并提交表单
      async submitForm() {
        try {
          this.isLoading = true

          // 1. 校验基本表单
          const basicFormData = await this.$refs.adGroupForm.validate()

          // 2. 校验banner位置表单
          const bannerPositionData = await this.$refs.bannerPosition.validateAllForms(this.slotKeys)

          const banners = Object.keys(bannerPositionData.allPositionsData).map((key) => {
            return bannerPositionData.allPositionsData[key]
          })
          // 3. 合并数据
          const submitData = {
            ...basicFormData,
            banner: banners.map((item) => {
              item.areaIdList = item.areaIdList
                ? item.areaIdList.map((item) => (Array.isArray(item) ? item.at(-1) : item))
                : undefined
              item.templateSloKey = item.slotKey
              item.displayChannel = item.displayChannelList
                ? item.displayChannelList.map((channel) => Number(channel))
                : []
              item.displayChannelList = item.displayChannelList
                ? item.displayChannelList.map((channel) => Number(channel))
                : []
              item.locationKey = this.locationKeyList[0]
                ? this.locationKeyList[0].advertisingLocationKey
                : ''
              return item
            }),
            state: 1,
            position: 0
          }

          // 4. 根据模式提交数据
          let res
          if (this.isEdit) {
            res = await addOrUpdateAdGroup(submitData)
          } else {
            res = await addOrUpdateAdGroup(submitData)
          }

          // 5. 处理响应
          if (res.code === 0) {
            this.$message.success(this.isEdit ? '编辑广告组成功' : '新增广告组成功')
            // 清除缓存
            this.clearCache()
            this.$store.commit('DEL_TAG', this.$store.getters.tag)
            this.$router.replace('/FooterBannerList')
          } else {
            this.$message.error(res.message || '操作失败')
          }
        } catch (error) {
          console.error('提交表单失败:', error)
          // this.$message.error(error.message || '表单验证失败')
        } finally {
          this.isLoading = false
        }
      },

      // 保存草稿
      async saveDraft() {
        try {
          this.isLoading = true

          // 1. 校验基本表单
          const basicFormData = await this.$refs.adGroupForm.validate()

          // 2. 获取banner位置数据（不校验）
          const bannerPositionData = this.$refs.bannerPosition.getAllData()

          const banners = Object.keys(bannerPositionData.allPositionsData).map((key) => {
            return bannerPositionData.allPositionsData[key]
          })

          // 3. 合并数据
          const submitData = {
            ...basicFormData,
            banner: banners.map((item) => {
              item.areaIdList = item.areaIdList
                ? item.areaIdList.map((item) => item.at(-1))
                : undefined
              item.templateSloKey = item.slotKey
              item.displayChannel = item.displayChannelList
                ? item.displayChannelList.map((channel) => Number(channel))
                : []
              item.displayChannelList = item.displayChannelList
                ? item.displayChannelList.map((channel) => Number(channel))
                : []
              item.locationKey = this.locationKeyList[0]
                ? this.locationKeyList[0].advertisingLocationKey
                : ''
              return item
            }),
            state: 0, // 草稿状态
            position: 0
          }

          console.log('submitData', submitData)

          // 4. 提交数据
          const res = await addOrUpdateAdGroup(submitData)

          // 5. 处理响应
          if (res.code === 0) {
            this.$message.success('保存草稿成功')
            // 清除缓存
            this.clearCache()
            this.$store.commit('DEL_TAG', this.$store.getters.tag)
            this.$router.replace('/FooterBannerList')
          } else {
            this.$message.error(res.message || '保存草稿失败')
          }
        } catch (error) {
          console.error('保存草稿失败:', error)
          this.$message.error(error.message || '表单验证失败')
        } finally {
          this.isLoading = false
        }
      },

      // 返回上一页
      goBack() {
        this.$router.go(-1)
      },

      // 处理取消
      handleCancel() {
        this.$confirm('确定要取消操作吗？未保存的数据将丢失', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            // 清除缓存
            this.clearCache()
            this.$store.commit('DEL_TAG', this.$store.getters.tag)
            this.$router.replace('/FooterBannerList')
          })
          .catch(() => {})
      },

      // 处理上一步
      handlePrev() {
        this.$refs.bannerPosition.handlePrev()
      },

      // 处理下一步
      handleNext() {
        this.$refs.bannerPosition.handleNext()
      }
    }
  }
</script>

<template>
  <div class="ad-group-editor">
    <div class="editor-container">
      <div class="editor-left">
        <!-- 基本信息表单 -->
        <div class="section-title">基本信息</div>
        <AdGroupForm
          ref="adGroupForm"
          v-model="form"
          :is-edit="isEdit"
          :is-simple-mode="isSimpleMode"
          @template-change="handleTemplateChange"
          @change="handleFormChange"
          :banner-templates="bannerTemplates"
          :allow-cache="cacheEnabled"
        />

        <!-- Banner位置配置 -->
        <div class="section-title"
          >Banner位配置
          <span style="color: red; font-size: 12px"
            >为每个banner位配置对应内容，所有 banner位配置完成后可以提交审核</span
          ></div
        >
        <BannerPosition
          ref="bannerPosition"
          v-model="form"
          :slot-keys="slotKeys"
          :is-edit="isEdit"
          :is-simple-mode="isSimpleMode"
          :default-banners="defaultBanners"
          @change="handleBannerPositionChange"
          :allow-cache="cacheEnabled"
        />
      </div>

      <!-- 预览部分 -->
      <div class="editor-right" v-if="form.templateId">
        <div class="section-title">预览</div>
        <BannerPreview :showTitle="false">
          <template #imgSlot>
            <div class="preview-img-container">
              <img :src="previewImg" alt="Banner预览" class="preview-img" />
            </div>
          </template>
        </BannerPreview>
      </div>
    </div>

    <!-- 操作按钮 -->
    <OperationButtons
      :current-index="$refs.bannerPosition ? $refs.bannerPosition.getCurrentIndex() : 0"
      :total-steps="slotKeys.length"
      :show-save-draft="!isSimpleMode"
      :is-edit="isEdit"
      @cancel="handleCancel"
      @save-draft="saveDraft"
      @prev="handlePrev"
      @next="handleNext"
      @submit="submitForm"
      :cancelText="isEdit ? '取消编辑' : '取消新增'"
    />
  </div>
</template>

<style scoped lang="scss">
  .ad-group-editor {
    padding: 20px;

    .section-title {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 15px;
      padding-left: 10px;
      border-left: 3px solid #409eff;
    }

    .editor-container {
      display: flex;
      margin-bottom: 20px;

      .editor-left {
        flex: 1;
        padding-right: 20px;
      }

      .editor-right {
        width: 600px;
        margin-left: 20px;
      }
    }

    .preview-img-container {
      width: 300px;

      .preview-img {
        width: 100%;
      }
    }
  }
</style>
